module.exports = __webpack_public_path__ + "img/环保便利.963ed5a8.png";